export default "<h1>Grips</h1>\n\n<div class=\"table\">\n  <app-gripper-activation-list></app-gripper-activation-list>\n</div>\n"